"use client";

import { c as _c } from "react/compiler-runtime";
import { geoQueryOptions } from "@repo/design-system/lib/react-query";
import type { GeoApifyPayload, Geosearch } from "@repo/design-system/utils/geoapify/geoapify";
import { useQuery } from "@tanstack/react-query";
export function useGeoapify(payload, opts) {
  const $ = _c(6);
  let t0;
  if ($[0] !== opts?.enabled || $[1] !== payload) {
    t0 = payload.type === "geo" ? isGeoSearchPayload(payload) && (opts?.enabled ?? true) : opts?.enabled ?? true;
    $[0] = opts?.enabled;
    $[1] = payload;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const enabled = t0;
  let t1;
  if ($[3] !== enabled || $[4] !== payload) {
    t1 = geoQueryOptions.search(payload, enabled);
    $[3] = enabled;
    $[4] = payload;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return useQuery(t1);
}
function isGeoSearchPayload(payload: GeoApifyPayload): payload is Geosearch {
  return payload.type === "geo" && typeof (payload as {
    query?: unknown;
  }).query === "string" && (payload as {
    query: string;
  }).query.trim().length > 0;
}